var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 65,
    viewBox: "0 0 237 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_119_19521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.40723C13.1745 1.40723 13.1745 15.6233 26.3491 15.6233C39.5236 15.6233 39.5236 1.40723 52.6981 1.40723C65.8727 1.40723 65.8727 15.6233 79.0472 15.6233C92.2217 15.6233 92.1936 1.40723 105.368 1.40723C118.543 1.40723 118.543 15.6233 131.717 15.6233C144.892 15.6233 144.892 1.40723 158.066 1.40723C171.241 1.40723 171.241 15.6233 184.415 15.6233C197.59 15.6233 197.59 1.40723 210.793 1.40723C223.995 1.40723 223.967 15.6233 237.17 15.6233",
    stroke: "#C7C7C7",
    strokeWidth: 2.81507,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 25.3906C13.1745 25.3906 13.1745 39.6067 26.3491 39.6067C39.5236 39.6067 39.5236 25.3906 52.6981 25.3906C65.8727 25.3906 65.8727 39.6067 79.0472 39.6067C92.2217 39.6067 92.2217 25.3906 105.396 25.3906C118.571 25.3906 118.571 39.6067 131.745 39.6067C144.92 39.6067 144.92 25.3906 158.094 25.3906C171.269 25.3906 171.269 39.6067 184.443 39.6067C197.618 39.6067 197.618 25.3906 210.821 25.3906C224.023 25.3906 223.995 39.6067 237.198 39.6067",
    stroke: "#C7C7C7",
    strokeWidth: 2.81507,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 49.377C13.1745 49.377 13.1745 63.5931 26.3491 63.5931C39.5236 63.5931 39.5236 49.377 52.6981 49.377C65.8727 49.377 65.8727 63.5931 79.0472 63.5931C92.2217 63.5931 92.2217 49.377 105.396 49.377C118.571 49.377 118.571 63.5931 131.745 63.5931C144.92 63.5931 144.92 49.377 158.094 49.377C171.269 49.377 171.269 63.5931 184.443 63.5931C197.618 63.5931 197.618 49.377 210.821 49.377C224.023 49.377 223.995 63.5931 237.198 63.5931",
    stroke: "#C7C7C7",
    strokeWidth: 2.81507,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_19521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 237.142,
    height: 65,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.8c48c4b65270f4088da117c5f94cf8e9.svg";
export { ForwardRef as ReactComponent };